import {
    UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_SUCCESS,
    UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_FAILED,
    RESET_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER,
    LOADING_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER,
    NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: "",
};

export default (state = initialState, action) => {

    switch (action.type) {
        case LOADING_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: "",
            };
        case UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case UPDATEGATEWAYTRANSACTIONSTATUSPARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: "",
            };
        case NETWORK_ERROR_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: "",
            };
        case RESET_UPDATEGATEWAYTRANSACTIONSTATUSPARTNER:
            return (state = initialState);
        default:
            return state;
    }
};
